/**
 * Determines if the provided value is a plain object (excluding arrays, null, and undefined).
 *
 * @param value - The value to check.
 * @returns True if the value is a non-null, non-array object; otherwise, false.
 */
export const isObject = (value: unknown): value is Record<string, unknown> => {
  if (value === undefined || value === null || Array.isArray(value)) {
    return false;
  }

  return typeof value === 'object' && typeof value.constructor === 'function';
};
